import React from 'react'

function Iotlist() {
  return (
    <div>Iotlist</div>
  )
}

export default Iotlist